import { render, staticRenderFns } from "./CRMApplicationCard.vue?vue&type=template&id=44a2dd00&scoped=true&"
import script from "./CRMApplicationCard.vue?vue&type=script&lang=js&"
export * from "./CRMApplicationCard.vue?vue&type=script&lang=js&"
import style0 from "./CRMApplicationCard.vue?vue&type=style&index=0&id=44a2dd00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a2dd00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VHover,VIcon})
